<template>
  <BaseDialog type="basic" :is-open="isOpen" @close="emits('close')">
    <div class="flex w-full items-center justify-center py-6">
      <BaseShapeMask shape="8-leaf-clover" animation="spin">
        <BaseMemberAvatar size="128" :member="coach" />
      </BaseShapeMask>
    </div>
    <h2 class="text-headline-medium mb-2">Möchtest du den Dialog freigeben?</h2>
    <p class="text-body-large">
      {{ $t('dialog.release.coachDescription') }}
    </p>
    <div
      class="bg-tertiary-container text-on-tertiary-container rounded-large mt-8 flex items-center gap-3 p-4"
    >
      <BaseIcon size="24">warning</BaseIcon>
      <p class="text-title-medium">Dieser Schritt kann von dir nicht rückgängig gemacht werden.</p>
    </div>
    <div
      v-if="isDirty"
      class="bg-tertiary-container text-on-tertiary-container rounded-large mt-2 flex items-center gap-3 p-4"
    >
      <BaseIcon size="24">warning</BaseIcon>
      <p class="text-title-medium">
        Auf der aktuellen Seite hast du noch ungespeicherte Änderungen.
      </p>
    </div>

    <div
      v-if="unfinishedTopics.length > 0"
      class="bg-tertiary-container text-on-tertiary-container rounded-large mt-2 p-3"
    >
      <h4 class="text-title-medium mb-1">
        Schliesse erst alle Themen ab, bevor du den Dialog freigeben kannst.
      </h4>
      <ul class="mt-4 ml-1 flex flex-col gap-1">
        <li v-for="feedbackTopic in unfinishedTopics" :key="feedbackTopic.id" class="flex flex-row">
          <BaseIcon size="18" class="mr-2">{{ feedbackTopic.icon }}</BaseIcon>
          <span class="text-body-medium">{{ feedbackTopic.title }}</span>
        </li>
      </ul>
    </div>
    <div
      v-if="hasUnfinishedSurveys"
      class="bg-tertiary-container text-on-tertiary-container rounded-large mt-2 p-3"
    >
      <h4 class="text-title-medium">Nicht abgeschlossene Umfragen ausgewählt.</h4>
      <p class="text-body-medium">Du hast Umfragen ausgwählt, die noch nicht abgeschlossen sind.</p>
    </div>
    <template #dismiss
      ><BaseTextButton size="M" @click="emits('close')">{{
        $t('common.cancel')
      }}</BaseTextButton></template
    >
    <template #confirm
      ><BaseTextButton size="M" @click="emits('releaseDialog')" :disabled="disabled || isDirty">{{
        $t('dialog.release.action')
      }}</BaseTextButton></template
    >
  </BaseDialog>
</template>

<script lang="ts" setup>
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseShapeMask from '@/core/components/base/shapes/BaseShapeMask.vue'
  import type { FeedbackTopic } from '@/core/models/feedback-topic'
  import type { Member } from '@/core/models/member/member'
  import { useUnsavedChangesStore } from '@/stores/unsaved-changes.store'
  import { storeToRefs } from 'pinia'

  interface Props {
    isOpen: boolean
    disabled?: boolean
    unfinishedTopics: FeedbackTopic[]
    hasUnfinishedSurveys: boolean
    coach: Member
  }

  defineProps<Props>()

  const emits = defineEmits<{
    (e: 'close'): void
    (e: 'releaseDialog'): void
  }>()

  const { isDirty } = storeToRefs(useUnsavedChangesStore())
</script>
